import React, { useEffect, useState,useLayoutEffect }  from 'react';
import SockJsClient from 'react-stomp';
import checkout from '../style/checkout.module.css'
import formStyle from '../style/form.module.css'
import {
  FaArrowLeft,
} from 'react-icons/fa'

import UrlService from '../service/url_service'
import Modal from './sub/modal'
import Footer from './sub/footer'
import Secured from './sub/secured_design'
import Loader from './sub/loader'

export const SettlementAccount = ({ title,mobileNumber, callback,styleData }) => {
  const [loading, setLoading] = useState(true)
  const [sockStatus, setSockStatus] = useState(false);
  const [clientRef, setClientRef] = useState(null);

  const [banks, setBanks] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  
  const [openModal, setModal] = useState(false)
  const [walletResponse, setWalletResponse] = useState(false);

  const [bankCode, setBankCode] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [act, setAct] = useState(null);

  useEffect(() => {
  //   AppService.getMainOrders(null).then(rec => {
  //     if (rec.error) {
  //     } else {
  //         setData(rec.noOfRecords)
  //     }
  // })
  
  }, []);

  useLayoutEffect(() => () => {
    // Your code here.
    if(clientRef)
      clientRef.disconnect();

    setWalletResponse(null);
    setBankCode(null);
    setAccountNumber(null);
  }, [])



  const accountEnquiry = () => {
    let data = {};
    data.channel = mobileNumber;
    data.bankCode = bankCode.split(',')[0];
    data.accountNumber = accountNumber;
    setLoading(true);
    clientRef.sendMessage('/app/account/enquiry', JSON.stringify(data));
    
};

const updateAccount = () => {
    let data = {};
    data.settlementAccount = {};
    data.mobileNumber = mobileNumber;
    data.settlementAccount.outBankCode = bankCode.split(',')[0];
    data.settlementAccount.outBankName = bankCode.split(',')[1];
    data.settlementAccount.outAccountNo = accountNumber;
    data.settlementAccount.outAccountName = walletResponse.AccountName;
    // setLoading(true);
    clientRef.sendMessage('/app/put/settlement/account', JSON.stringify(data));

    data = {};
    data.action = "ACCOUNT_UPDATE";
    data.bankCode = bankCode.split(',')[0];
    data.bankName = bankCode.split(',')[1];
    data.accountNumber = accountNumber;
    data.accountName = walletResponse.AccountName;
    data.response = {
      responseCode: "200",
      responseMessage: "Successful"
    };
    callback(data);
    setModal(false);
    
};

const setAccount = (account) => {
  setAct(account);
  let data = {};
  data.action = "ACCOUNT_INFO";
  data.account = account;
  data.response = {
    responseCode: "200",
    responseMessage: "Successful"
  };
  callback(data);
  
};

  const renderItems = <div className={formStyle.form_wrapper}>
  <div className={formStyle.form_container}>
     <div className={formStyle.title_container}>
        {/* <h2>Settlement Account</h2> */}
     </div>
     <div className={`${formStyle.clearfix} ${formStyle.row} `}>
        <div >
        {act && <p style={{marginTop: '-40px'}}>
                      A/c Name: {act.outAccountName}
                      <br />
                      A/c No: {act.outAccountNo}
                      <br />
                      Bank Name:  {act.outBankName}
                    </p>}
           <form onSubmit={(e) => e.preventDefault()}>
              <div className={formStyle.input_field}> <span><i aria-hidden="true" className="fa fa-envelope" /></span>
                 <input type="text" name="accountNumber" placeholder="Account Number" value={accountNumber? accountNumber : ''} required onChange={(e) => setAccountNumber(e.target.value)} />
              </div>
              <div>
                     {bankCode && bankCode.split(',')[1]}
                 </div>
              <div className={`${formStyle.input_field} ${formStyle.select_option} `}>
                 <select onChange={(e) => setBankCode(e.target.value)} >
                    <option key="xio">Select a bank</option>
                    {
                        banks && banks.length > 0 && banks.map((item,index) => {
                            return <option key={index} value={item.BankCode+","+item.BankName}>{item.BankName}</option>
                        })
                    }
                 </select>
                 <div className={formStyle.select_arrow} />
                 </div>
                 <div>
                     {walletResponse && walletResponse.AccountName}
                 </div>
                 {errorMessage && <span style={{color: 'red'}}>
                      {errorMessage}
                    </span>}
                 {!walletResponse && <input className={formStyle.button} onClick={accountEnquiry} type="submit" value="Validate Account" />}
                 {walletResponse && <input className={formStyle.button} onClick={updateAccount} type="submit" value="Update Account" />}
           </form>
           </div>
        </div>
     </div>
  </div>

 
    return (
      <React.Fragment>
         <Modal isOpen={openModal} onClose={() => setModal(false)}>
          <div className={checkout.checkout_ui}>
            <button
              className={checkout.close_modal}
              onClick={() =>setModal(false)}
            >
              &times;
            </button>
            <div className={checkout.modal_container}>
              {/* left side */}
              <div className={checkout.section_left}>
                <div className={checkout.head} onClick={() => setModal(false)} >
                  <div className={checkout.arrow}>
                    <FaArrowLeft />
                  </div>

                  <h4>Close</h4>
                </div>
                <div className={checkout.cart_content}>
                  <div className={checkout.cart_content_bottom}>
                    <p>Payout Account</p>
                    
                    
                    <Secured sockStatus={sockStatus} />
                    
                  </div>
                </div>
                {(loading || !sockStatus) && <Loader />}
                {!loading && sockStatus && <div className={checkout.cart_items}>{renderItems}</div>}
              </div>
              <Footer />
            </div>
          </div>
        </Modal>
        {styleData ? <styleData.cover className={styleData.class}
           onClick={() => setModal(true)} >
                {styleData.title}
            </styleData.cover>
            : <button
            className={`${checkout.xbtn} ${checkout.inverted} `}
            onClick={() => setModal(true)}
            style={{position: null}}
          >
            {title ? title : "Settlement Account"}
            
          </button>}
        

          {openModal && <SockJsClient url={UrlService.BASE_PATH + '/unified/'}
                                topics={['/queue/settlement/account/manager/'+mobileNumber,'/queue/channel/'+mobileNumber]}
                                onConnect={() => {
                                    // console.log("connected");
                                    let data = {};
                                    data.mobileNumber = mobileNumber;
                                    data.channel = mobileNumber;
                                    
                                    setSockStatus(true);
                                    clientRef.sendMessage('/app/get/settlement/account', JSON.stringify(data));
                                    clientRef.sendMessage('/app/banks', JSON.stringify(data));
                                }}
                                onDisconnect={() => {
                                    // console.log("Disconnected");
                                    setSockStatus(false)
                                }}
                                onMessage={(msg) => {
                                    console.log("mssg", msg)
                                    setLoading(false)
                                    if(msg.action === "GET"){
                                      setAccount(msg.settlementAccount)
                                    }
                                    else if(msg.action === "BANKS"){
                                        setBanks(msg.banks)
                                    }else if (msg.action === "ENQUIRY"){
                                        setWalletResponse(msg.walletResponse)
                                    }else if(msg.action === "PUT"){
                                        setAccount(msg.settlementAccount)
                                    }else if(msg.action === "ERROR"){
                                      setErrorMessage(msg.message);
                                      setTimeout(() => {
                                        setErrorMessage(null);
                                      }, 10000);
                                    }
                                    

                                    

                                    // console.log(state);
                                }}
                                ref={(client) => {
                                  setClientRef(client)
                                }} />}
      </React.Fragment>
    )
  }


//export default CheckOut
